import React from 'react';
import { PageShell } from '../components/PageShell';
import { PortraitFrame } from '../components/PortraitFrame';
import { SectionHeading } from '../components/SectionHeading';
import { about } from '../data/profile';
export function About() {
  return <PageShell path="/about" data-id="element-127" data-mp="29hive6y3it0m">
      <section className="bg-white py-20 lg:py-24" aria-labelledby="biography-heading" data-id="element-128" data-mp="2eigm57x68vdq">
        <div className="mx-auto grid w-full max-w-7xl grid-cols-1 gap-14 px-6 lg:grid-cols-12 lg:gap-16 lg:px-10" data-id="element-129" data-mp="328axtm5r8dwe">
          <div className="lg:col-span-7" data-id="element-130" data-mp="377xc7yxbk06s">
            <div id="biography-heading" data-id="element-131" data-mp="376vpgx6xxp98">
              <SectionHeading eyebrow="Biography" title="A governance executive, plainly described" data-id="element-132" data-mp="2sa4vj3g1d5r0" />
            </div>
            <div className="mt-8 space-y-6" data-id="element-133" data-mp="2x8oj18aa2plh">
              {about.biography.map(paragraph => <p key={paragraph.slice(0, 32)} className="font-sans text-base leading-relaxed text-charcoal-700 lg:text-lg" data-id="element-134" data-mp="1gug8kc2s86q7">
                  {paragraph}
                </p>)}
            </div>
          </div>

          <div className="lg:col-span-5" data-id="element-135" data-mp="1pip1hn8n0v60">
            <div className="bg-navy-900 p-8 lg:p-10" data-id="element-136" data-mp="1pk0dgac8l987">
              <PortraitFrame size="sm" data-id="element-137" data-mp="23iggnraw4hll" />
            </div>
            <dl className="mt-8 divide-y divide-platinum-200 border-y border-platinum-200" data-id="element-138" data-mp="23k1djnkogcmm">
              {about.glance.map(item => <div key={item.label} className="flex items-baseline justify-between gap-6 py-4" data-id="element-139" data-mp="2dgnx8919oxn2">
                  <dt className="font-sans text-sm text-charcoal-600" data-id="element-140" data-mp="28hkremdgqne1">{item.label}</dt>
                  <dd className="text-right font-display text-sm font-bold text-navy-900" data-id="element-141" data-mp="28fqftyo307mm">
                    {item.value}
                  </dd>
                </div>)}
            </dl>
          </div>
        </div>
      </section>

      <section className="bg-platinum-100 py-20 lg:py-24" aria-labelledby="philosophy-heading" data-id="element-142" data-mp="2w8708fvakbp3">
        <div className="mx-auto w-full max-w-7xl px-6 lg:px-10" data-id="element-143" data-mp="2r8u577u9nybf">
          <div id="philosophy-heading" data-id="element-144" data-mp="1oumt84pos4qv">
            <SectionHeading eyebrow="Leadership Philosophy" title="Three convictions that shape how she leads" data-id="element-145" data-mp="1ovo2q4r20j6h" />
          </div>
          <ul className="mt-12 grid grid-cols-1 gap-px border border-platinum-200 bg-platinum-200 lg:grid-cols-3" data-id="element-146" data-mp="1xvkwulw7qa8x">
            {about.philosophy.map((item, index) => <li key={item.title} className="flex flex-col bg-white p-8 lg:p-10" data-id="element-147" data-mp="22o47pb3imra1" data-mpi={index}>
                <span className="font-display text-sm font-bold tracking-[0.12em] text-gold-600" data-id="element-148" data-mp="27kuq452slyym">
                  {String(index + 1).padStart(2, '0')}
                </span>
                <h3 className="mt-4 font-display text-lg font-bold leading-snug tracking-tight text-navy-900" data-id="element-149" data-mp="2gn3zgrmbrmaf">
                  {item.title}
                </h3>
                <p className="mt-auto pt-4 font-sans text-sm leading-relaxed text-charcoal-600" data-id="element-150" data-mp="m81f18c4uued">
                  {item.text}
                </p>
              </li>)}
          </ul>
        </div>
      </section>
    </PageShell>;
}